export default __webpack_public_path__ + "static/media/pagination__active.20ae345b.svg";